import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { TEL_LINK, WA_LINK, PHONE_FORMATTED } from "../constants/contact";

const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
  </svg>
);

const NAV = [
  { label: "Hizmetler", href: "/#hizmetler", testid: "nav-services-link" },
  { label: "Neden Biz", href: "/#neden-biz", testid: "nav-why-link" },
  { label: "Bölgeler", href: "/#bolgeler", testid: "nav-area-link" },
];

export const Header = () => (
  <header
    data-testid="site-header"
    className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-[#070A0F]/80 border-b border-slate-800/70"
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 sm:h-[72px] flex items-center justify-between gap-4">
      <a href="/" data-testid="header-brand-link" className="flex items-center gap-3 shrink-0">
        <Logo size={36} />
        <span className="font-display font-bold tracking-tight text-sm sm:text-base leading-tight text-slate-50">
          BEYLİKDÜZÜ
          <span className="block text-[10px] sm:text-xs font-mono font-medium tracking-[0.25em] text-amber-400">
            ELEKTRİKÇİ
          </span>
        </span>
      </a>

      <nav className="hidden md:flex items-center gap-8" data-testid="header-nav">
        {NAV.map((item) => (
          <a
            key={item.href}
            href={item.href}
            data-testid={item.testid}
            className="text-sm font-medium text-slate-400 hover:text-amber-400 transition-colors duration-200"
          >
            {item.label}
          </a>
        ))}
      </nav>

      <div className="flex items-center gap-2 sm:gap-3">
        <a
          href={WA_LINK}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="header-whatsapp-button"
          aria-label="WhatsApp ile yaz"
          className="hidden sm:flex items-center justify-center w-10 h-10 rounded-full bg-green-500/10 border border-green-500/40 text-green-400 hover:bg-green-500 hover:text-black transition-colors duration-200"
        >
          <WhatsAppIcon className="w-[18px] h-[18px]" />
        </a>
        <a
          href={TEL_LINK}
          data-testid="header-call-button"
          className="flex items-center gap-2 rounded-full bg-amber-500 hover:bg-amber-400 text-black font-display font-bold text-xs sm:text-sm px-4 sm:px-5 py-2.5 transition-colors duration-200 shadow-[0_0_24px_rgba(245,158,11,0.35)]"
        >
          <Phone className="w-4 h-4" strokeWidth={2.5} />
          <span className="hidden xs:inline sm:inline">{PHONE_FORMATTED}</span>
          <span className="xs:hidden sm:hidden">ARA</span>
        </a>
      </div>
    </div>
  </header>
);
